import { useSessionStorage } from '@vueuse/core';

const resource = {
  namespaced: true,
  state: {
    // dataResourceCatalogSideParams: useSessionStorage('dataResourceCatalogSideParams', {
    //   currentType: 'dbo',
    //   currentTypeView: 'Business View',
    //   categoryId: null,
    //   displayName: null,
    // }),
    dataResourceCatalogSideParams: {},
    tabs: [],
    sideData: null,
  },
  mutations: {
    INIT_SIDE_PARAMS: (state: any) => {
      if (state.sideData?.length) {
        state.dataResourceCatalogSideParams = {
          currentType: state.sideData[0].type,
          currentTypeView: 'Business View',
          // categoryId: state.sideData[0].category[0].id,
          // displayName: state.sideData[0].category[0].displayName,
          categoryId: null,
          displayName: '',
        };
      }
    },
    SET_SIDE_PARAMS: (state: any, params: any) => {
      state.dataResourceCatalogSideParams = params;
    },
    SET_TABS: (state: any, params: any) => {
      state.tabs = params;
    },
    SET_SIDE_DATA: (state: any, data: any) => {
      state.sideData = data;
    },
  },
  actions: {},
};

export default resource;
